import React from 'react';
import {connect} from "react-redux";

class RewardTitleComponent extends React.Component {

	componentWillMount() {
		this.props.fetchReward(this.props.friendlyName);
	}

	render() {
		return this.props.error ? null : <h1 className="reward-detail-title extraBold">{this.props.title}</h1>;
	}

}

export default connect(
	(state) => {
		return {
			title: state.reward.item ? state.reward.item.title : null,
			error: state.reward.error
		}
	}, (dispatch) => {
		return {
			fetchReward: (friendlyName) => {
				dispatch({
					type: 'FETCH_REWARD',
					friendlyName
				})
			}
		}
	}
)(RewardTitleComponent)
